import { render, staticRenderFns } from "./superSearchDataChoice.vue?vue&type=template&id=70a95b01&"
import script from "./superSearchDataChoice.vue?vue&type=script&lang=js&"
export * from "./superSearchDataChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/superSearch/superSearchDataChoice.vue"
export default component.exports